// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N3g0","colBig":"styles_colBig__11S0d","colSmall":"styles_colSmall__2N51p","shopifyNameWrapper":"styles_shopifyNameWrapper__3VSHr"};